/**
 * VE-30855 — the two values the media editor route's `confirmLeave` returns
 * (src/redact-app/pages/routes.ts).
 *
 * They are signals, not UI copy: nothing displays them. The save modal renders
 * its own i18n text (`saveContentModal`), so these never need translating.
 *
 * redux-first-router hands `displayConfirmLeave` only the message, never the
 * held action, so the message is the one thing that tells the save modal's
 * Discard where the reviewer was going. Discard on a Home exit owns the extras
 * (case-folder re-select, Investigate `window.close()`, REDIRECT_TO_HOME); on
 * any other exit it must only release the held navigation, or a file switch
 * lands on Home. MediaDetailsTopBar runs the Home extras only on an exact
 * MEDIA_LEAVE_TO_HOME_SIGNAL match; anything else just releases the held
 * navigation, so a drifted value fails toward "go where the user clicked".
 */
export const MEDIA_LEAVE_TO_HOME_SIGNAL = 'media-leave:home';

export const MEDIA_LEAVE_ELSEWHERE_SIGNAL = 'media-leave:elsewhere';

export type MediaLeaveSignal =
  | typeof MEDIA_LEAVE_TO_HOME_SIGNAL
  | typeof MEDIA_LEAVE_ELSEWHERE_SIGNAL;
